<template>

  <div class="table">
    <div class="header-all">
      <div class="header">
        <div v-for="(item, index) in header"
             :key="index"
             class="h-item">
          <div class="title">
            {{ item.title }}
          </div>
          <div class="body"
               v-for="(form, formIndex) in form"
               :key="formIndex"
               @click="updateInfo(form, formIndex)">
            <div v-if="form.type == 2"
                 class="b-item">
              <div style="position: absolute;top:5px;right: 10px;font-size:20px;width:40px"
                   :style="{color: (form.peakFullPriceNum ||
                    form.peakHalfPriceNum ||
                    form.peakStudentNum ||
                    form.peakOldNum ||
                    form.peakFreeNum?'red':'#ffb940')}"
                   v-if="index == 0">
                {{form.peakFullPriceNum ||
                    form.peakHalfPriceNum ||
                    form.peakStudentNum ||
                    form.peakOldNum ||
                    form.peakFreeNum?'旺季':'淡季'}}
              </div>
              <div v-if="index == 0">
                {{ form.item }}
              </div>
              <div v-if="index == 1"
                   class="tow-type">
                <div v-if="form.peakFullPriceNum ||
                    form.peakHalfPriceNum ||
                    form.peakStudentNum ||
                    form.peakOldNum ||
                    form.peakFreeNum">
                  <div v-if="form.peakFullPriceNum ">
                    全价（{{ form.peakPriceFull }}）
                  </div>
                  <div v-if="form.peakHalfPriceNum">
                    半价（{{ form.peakPriceHalf }}）
                  </div>
                  <div v-if="form.peakStudentNum">
                    学生（{{ form.peakStudent }}）
                  </div>
                  <div v-if="form.peakOldNum">
                    老人（{{ form.peakOld }}）
                  </div>
                  <div v-if="form.peakFreeNum">
                    免票（{{ form.peakFree }}）
                  </div>
                </div>
                <div v-else
                     class="tow-type">
                  <div v-if="form.offPeakFullPriceNum">
                    全价（{{ form.offPeakPriceFull }}）
                  </div>
                  <div v-if="form.offPeakHalfPriceNum">
                    半价（{{form.offPeakPriceHalf }}）
                  </div>
                  <div v-if="form.offPeakStudentNum">
                    学生（{{ form.offPeakStudent }}）
                  </div>
                  <div v-if="form.offPeakOldNum">
                    老人（{{ form.offPeakOld }}）
                  </div>
                  <div v-if="form.offPeakFreeNum">
                    免票（{{ form.offPeakFree }}）
                  </div>
                </div>
              </div>
              <div v-if="index == 2"
                   class="tow-type">
                <div v-if="form.peakFullPriceNum ||
                    form.peakHalfPriceNum ||
                    form.peakStudentNum ||
                    form.peakOldNum ||
                    form.peakFreeNum">
                  <div v-if="form.peakFullPriceNum">
                    {{ form.peakFullPriceNum }}
                  </div>
                  <div v-if="form.peakHalfPriceNum ">
                    {{ form.peakHalfPriceNum }}
                  </div>
                  <div v-if="form.peakStudentNum">
                    {{ form.peakStudentNum }}
                  </div>
                  <div v-if="form.peakOldNum">
                    {{ form.peakOldNum }}
                  </div>
                  <div v-if="form.peakFreeNum">
                    {{ form.peakFreeNum }}
                  </div>
                </div>
                <div v-else
                     class="tow-type">
                  <div v-if="form.offPeakFullPriceNum">
                    {{form.offPeakFullPriceNum }}
                  </div>
                  <div v-if="form.offPeakHalfPriceNum">
                    {{ form.offPeakHalfPriceNum }}
                  </div>
                  <div v-if="form.offPeakStudentNum">
                    {{ form.offPeakStudentNum }}
                  </div>
                  <div v-if="form.offPeakOldNum">
                    {{ form.offPeakOldNum }}
                  </div>
                  <div v-if="form.offPeakFreeNum">
                    {{ form.offPeakFreeNum }}
                  </div>
                </div>
              </div>
              <div v-if="index == 3"
                   style="height: 100%">{{
                  Number(form.peakFullPriceNum) * Number(form.peakPriceFull) +
                  Number(form.peakHalfPriceNum) * Number(form.peakPriceHalf) +
                  Number(form.peakStudentNum) * Number(form.peakStudent) +
                  Number(form.peakOldNum) * Number(form.peakOld) +
                  Number(form.peakFreeNum) * Number(form.peakFree) +
                  Number(form.offPeakFullPriceNum) * Number(form.offPeakPriceFull) +
                  Number(form.offPeakHalfPriceNum) * Number(form.offPeakPriceHalf) +
                  Number(form.offPeakStudentNum) * Number(form.offPeakStudent) +
                  Number(form.offPeakOldNum) * Number(form.offPeakOld) +
                  Number(form.offPeakFreeNum) * Number(form.offPeakFree)
                }}</div>
              <div v-if="index == 4"
                   style="height: 100%">{{
                form.hasInvoice == 1 ? "有发票" : "无"
              }}</div>
              <div v-if="index == 5"
                   style="height: 100%">{{
                  form.remark ? form.remark : ""
                }}</div>
              <div v-if="index == 6"
                   style="height: 100%">查看</div>
            </div>
            <div v-else>
              <span v-if="index == 0">
                {{ form.item }}
              </span>
              <div v-else
                   class="b-i-two">
                <template v-if="form.type == 0">
                  <span v-if="index == 1">{{ form.totalAmount }}</span>
                  <span v-if="index == 2">{{ form.groupPeople }}</span>
                </template>
                <template v-if="form.type == 1">
                  <span v-if="index == 1">{{ form.totalAmount }}</span>
                  <span v-if="index == 2">{{
                    form.hasInvoice == 1 ? "有发票" : "无"
                  }}</span>
                  <span v-if="index == 3">{{
                    form.remark ? form.remark : ""
                  }}</span>
                  <span v-if="index == 4"
                        style="cursor:pointer"
                        @click="seeImg(formIndex)">查看</span>
                </template>
                <template v-if="form.type == 3">
                  <span v-if="index == 1">{{ form.guestStandard }}</span>
                  <span v-if="index == 2">{{ form.guestCount }}</span>
                  <span v-if="index == 3">{{ form.guideStandard }}</span>
                  <span v-if="index == 4">{{ form.guideCount }}</span>
                  <span v-if="index == 5">{{ form.totalAmount }}</span>
                  <span v-if="index == 6">{{ form.otherAmount }}</span>
                  <span v-if="index == 7">{{
                    form.hasInvoice == 1 ? "有发票" : "无"
                  }}</span>
                  <span v-if="index == 8">{{
                    form.remark ? form.remark : ""
                  }}</span>
                  <span v-if="index == 9"
                        style="cursor:pointer"
                        @click="seeImg(formIndex)">查看</span>
                </template>
                <template v-if="form.type == 4">
                  <span v-if="index == 1">{{ form.totalAmount }}</span>
                  <span v-if="index == 2">{{
                    form.hasInvoice == 1 ? "有发票" : "无"
                  }}</span>
                  <span v-if="index == 3">{{
                    form.remark ? form.remark : ""
                  }}</span>
                  <span v-if="index == 4"
                        style="cursor:pointer"
                        @click="seeImg(formIndex)">查看</span>
                </template>
                <template v-if="form.type == 5">
                  <span v-if="index == 1 && form.doubleRoomCount">{{
                    `双(${form.doubleRoomCount}) `
                  }}</span>
                  <span v-if="index == 1 && form.singleRoomCount">{{
                    `单(${form.singleRoomCount}) `
                  }}</span>
                  <span v-if="index == 1 && form.tripleRoomCount">{{
                    `三(${form.tripleRoomCount}) `
                  }}</span>
                  <span v-if="index == 2">{{ form.guideRoomAmount }}</span>
                  <span v-if="index == 3">{{ form.guestRoomAmount }}</span>
                  <span v-if="index == 4">{{ form.days }}</span>

                  <span v-if="index == 5">{{
                    form.hasInvoice == 1 ? "有发票" : "无"
                  }}</span>
                  <span v-if="index == 6">{{
                    form.remark ? form.remark : ""
                  }}</span>
                  <span v-if="index == 7"
                        style="cursor:pointer"
                        @click="seeImg(formIndex)">查看</span>
                </template>
                <template v-if="form.type == 6">
                  <span v-if="index == 1">{{ form.totalAmount }}</span>
                  <span v-if="index == 2">{{
                    form.hasInvoice == 1 ? "有发票" : "无"
                  }}</span>
                  <span v-if="index == 3">{{
                    form.remark ? form.remark : ""
                  }}</span>
                  <span v-if="index == 4"
                        @click="seeImg(formIndex)"
                        style="cursor:pointer">查看</span>
                </template>
                <template v-if="form.type == 7">
                  <span v-if="index == 1">{{ form.totalAmount }}</span>
                  <span v-if="index == 2">{{
                    form.hasInvoice == 1 ? "有发票" : "无"
                  }}</span>
                  <span v-if="index == 3">{{
                    form.remark ? form.remark : ""
                  }}</span>
                  <span v-if="index == 4"
                        @click="seeImg(formIndex)"
                        style="cursor:pointer">查看</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="imgVisible"
             title="图片"
             width="80%"
             @cancel="handleCancel">
      <div style="display: flex; justify-content: center; align-items: center; width: 100%">
        <img v-for="(item, index) in imgUrlList"
             :src="item.invoice"
             :key="index"
             style="width:100%;height: auto;"
             alt="" />
      </div>
      <template v-slot:footer>
        <a-button @click="imgVisible = false"
                  type="primary">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: Array,
      default: () => {
        return []
      },
    },
    form: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      imgUrlList: [],
      imgVisible: false,
    }
  },
  methods: {
    handleCancel() {
      this.imgVisible = false
    },
    seeImg(index) {
      console.log(';;;', index)
      console.log(';;;', this.form[index])
      if (this.form[index] && this.form[index].invoices && this.form[index].invoices.length > 0) {
        this.imgUrlList = this.form[index].invoices
        this.imgVisible = true
      } else {
        this.$message.warning('暂无图片')
      }
    },
    updateInfo(form, index) {
      this.$emit('update-info', form, index)
    },
  },
}
</script>

<style lang="scss" scoped>
.table {
  border: 2px solid #dfdfdf;
  background: #ffffff;
  border-radius: 10px;
  width: 100%;

  ::-webkit-scrollbar {
    display: none;
  }
  .header-all {
    width: 100%;
    overflow-x: scroll;
    .header {
      border-radius: 10px 10px 0 0;
      display: flex;
      width: 100%;
      .h-item {
        border-right: 1px solid #dfdfdf;
        display: flex;
        min-width: 200px;
        font-weight: 600;
        font-size: 16px;
        color: #333333;
        flex-shrink: 0;
        flex-direction: column;
        flex: 1;
        .title {
          display: flex;
          background: #f5f5f5;
          height: 50px;
          min-width: 200px;
          justify-content: center;
          align-items: center;
        }
        .body {
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #dfdfdf;
          flex: 1;
          width: 100%;
          min-height: 50px;
          &:last-child {
            border-bottom: 0;
          }
          .b-item {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            max-height: 200px;
            min-height: 200px;
            div {
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              width: 100%;
            }
            .tow-type {
              div {
                display: flex;
                flex-direction: column;
                div {
                  border-bottom: 1px solid #dfdfdf;
                  flex: 1;
                }
                div:last-child {
                  border-bottom: 0;
                }
              }
            }
            .b-i-two {
              display: flex;
              flex-direction: column;
              width: 100%;
              flex: 1;

              div {
                width: 100%;
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
              }
            }
          }
        }
      }
      .h-item:last-child {
        border-right: 0;
      }
    }
  }
}
</style>
